// schema.ts
import * as yup from "yup";

export const addWaterSupplyValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  month: yup.mixed().required("Month is required"), // string or number—both ok
  year: yup.mixed().required("Year is required"), // string id or number—both ok
  destination: yup.string().required("Water source is required"),
  stressType: yup.string().required("Water stress type is required"),
  destinationType: yup.string().required("Water source type is required"),
  fuelUnit: yup.string().required("Unit is required"),
  usage: yup
    .number()
    // convert "33" -> 33; treat empty string as undefined so .required() triggers
    .transform((val, orig) =>
      orig === "" || orig === null || typeof orig === "undefined"
        ? undefined
        : Number(orig)
    )
    .typeError("Amount of water must be a valid number")
    .moreThan(0, "Usage must be greater than 0")
    .required("Amount of water is required"),
});
